const renderBorder = (selector, addclass = true, message = undefined) => {
  if (selector) {
    const element = document.querySelector(`[data-validation="${selector}"]`)
    if (element) {
      if (addclass) {
        element.classList.add('data-error')
        const errorMesssageElement = element.querySelector('.input-error-message')
        errorMesssageElement && errorMesssageElement.remove()
        if (message) {
          const errorMesssageElement = document.createElement('p')
          errorMesssageElement.className = 'input-error-message'
          errorMesssageElement.innerHTML = message
          element.append(errorMesssageElement)
        }
        const input = element.querySelector('input, textarea, select')
        if (input) {
          input.addEventListener('focus', () => {
            element.classList.remove('data-error')
            if (message) {
              const errorMesssageElement = element.querySelector('.input-error-message')
              errorMesssageElement.remove()
            }
          })
        }
      } else {
        element.classList.remove('data-error')
        const errorMesssageElement = element.querySelector('.input-error-message')
        errorMesssageElement && errorMesssageElement.remove()
      }
    }
  }
}

export default (selectors, addclass = true, message) => {
  if (typeof selectors === 'string') {
    renderBorder(selectors, addclass, message)
  } else if (Array.isArray(selectors)) {
    selectors.forEach(e => renderBorder(e, addclass, message))
  }
}

export const removeErrorBorder = (selectorArray) => {
  selectorArray.forEach(selector => {
    const elements = document.querySelectorAll(`[data-validation="${selector}"]`)
    elements.forEach((ele) => {
      ele.classList.remove('data-error')
      const errorMesssageElement = ele.querySelector('.input-error-message')
      errorMesssageElement && errorMesssageElement.remove()
    })
  })
}

export const borderHighlightOnly = (selectorClass, append = true) => {
  const element = document.querySelector(`.${selectorClass}`)
  if (!element) {
    return
  }
  if (append) {
    element.classList.add('error-border-clr')
    element.addEventListener('click', () => {
      element.classList.remove('error-border-clr')
    })
  } else {
    element.classList.remove('error-border-clr')
  }
}
